import React, { useState, useEffect } from 'react';
import { getTeamMembers } from '../services/api';

interface TeamMember { id: number; name: string; role: string; bio: string; initials: string; colorIndex: number; }

const colors = [
  'linear-gradient(135deg,#e85d04,#fb8500)',
  'linear-gradient(135deg,#0077b6,#00b4d8)',
  'linear-gradient(135deg,#2d6a4f,#40916c)',
  'linear-gradient(135deg,#6a0572,#9b1fae)',
  'linear-gradient(135deg,#c44d00,#e85d04)',
  'linear-gradient(135deg,#1a1a6e,#0077b6)',
];

const Team: React.FC = () => {
  const [team, setTeam] = useState<TeamMember[]>([]);
  useEffect(() => { getTeamMembers().then(r => { if (r.data?.length) setTeam(r.data); }).catch(()=>{}); }, []);
  return (
    <section className="section-py" id="team">
      <div className="container">
        <div className="section-label">Leadership</div>
        <h2 className="section-title">Meet Our Key Members</h2>
        <p style={{ color:'var(--text-secondary)', maxWidth:'560px', lineHeight:'1.75' }}>
          The experienced professionals driving NIDAVE's mission of engineering excellence and community development.
        </p>
        <div className="team-grid">
          {team.map((m, i) => (
            <div className="team-card" key={m.id}>
              <div className="team-card-header" style={{ background: colors[m.colorIndex ?? i % colors.length] }}>
                <div className="team-card-avatar">{m.initials || m.name.slice(0,2).toUpperCase()}</div>
              </div>
              <div className="team-card-body">
                <div className="team-card-name">{m.name}</div>
                <div className="team-card-role">{m.role}</div>
                <p className="team-card-bio">{m.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default Team;
